import api from "api/axios";

const BASE = "/admin/speciality-treatments";

export const getSpecialityTreatments = (params) => api.get(BASE, { params });

export const createSpecialityTreatment = (payload) => api.post(BASE, payload);

export const updateSpecialityTreatment = (id, payload) =>
  api.patch(`${BASE}/${id}`, payload);

export const deleteSpecialityTreatment = (id) => api.delete(`${BASE}/${id}`);

export const importSpecialityTreatments = (file) => {
  const body = new FormData();
  body.append("file", file);
  return api.post(`${BASE}/import`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/** kind = "template" | "export" */
export const downloadSpecialityTreatmentFile = (kind, params) =>
  api.get(`${BASE}/${kind}`, { params, responseType: "blob" });
